const Main = () => import(/* webpackChunkName: "exoty" */ '@/modules/main/main.vue');
const EmptyRouterView = () => import(/* webpackChunkName: "exoty" */ '@/components/EmptyRouter.vue');
const PicwordSetting = () => import(/* webpackChunkName: "picword" */ '@/modules/picword/setting/view/edit.vue');

const PicwordMapAdd = () => import(/* webpackChunkName: "picword" */ '@/modules/picword/map/view/add.vue');
const PicwordMapEdit = () => import(/* webpackChunkName: "picword" */ '@/modules/picword/map/view/edit.vue');
const PicwordMapDetail = () => import(/* webpackChunkName: "picword" */ '@/modules/picword/map/view/detail.vue');
const PicwordMapList = () => import(/* webpackChunkName: "picword" */ '@/modules/picword/map/view/index.vue');

const PicwordPetAdd = () => import(/* webpackChunkName: "picword" */ '@/modules/picword/pet/view/add.vue');
const PicwordPetEdit = () => import(/* webpackChunkName: "picword" */ '@/modules/picword/pet/view/edit.vue');
const PicwordPetDetail = () => import(/* webpackChunkName: "picword" */ '@/modules/picword/pet/view/detail.vue');
const PicwordPetList = () => import(/* webpackChunkName: "picword" */ '@/modules/picword/pet/view/index.vue');

export const ROUTE_NAME_PICWORD = {
    SETTING: 'PicwordSetting',
    MAP: {
        INDEX: 'PicwordMapList',
        ADD: 'PicwordMapAdd',
        EDIT: 'PicwordMapEdit',
        DETAIL: 'PicwordMapDetail'
    },
    PET: {
        INDEX: 'PicwordPetList',
        ADD: 'PicwordPetAdd',
        EDIT: 'PicwordPetEdit',
        DETAIL: 'PicwordPetDetail'
    }
} as const;

export default [
    {
        path: '/app/:appId/picword/',
        component: Main,
        meta: { requiresAuth: true },
        children: [
            {
                path: 'setting',
                name: ROUTE_NAME_PICWORD.SETTING,
                component: PicwordSetting,
                meta: { requiresAuth: true }
            },

            {
                path: 'map',
                component: EmptyRouterView,
                meta: { requiresAuth: true },
                children: [
                    {
                        path: '',
                        name: ROUTE_NAME_PICWORD.MAP.INDEX,
                        component: PicwordMapList,
                        meta: { requiresAuth: true }
                    },
                    {
                        path: 'add',
                        name: ROUTE_NAME_PICWORD.MAP.ADD,
                        component: PicwordMapAdd,
                        meta: { requiresAuth: true }
                    },
                    {
                        path: ':id/edit',
                        name: ROUTE_NAME_PICWORD.MAP.EDIT,
                        component: PicwordMapEdit,
                        meta: { requiresAuth: true }
                    },
                    {
                        path: ':id/detail',
                        name: ROUTE_NAME_PICWORD.MAP.DETAIL,
                        component: PicwordMapDetail,
                        meta: { requiresAuth: true }
                    }
                ]
            },

            {
                path: 'pet',
                component: EmptyRouterView,
                meta: { requiresAuth: true },
                children: [
                    {
                        path: '',
                        name: ROUTE_NAME_PICWORD.PET.INDEX,
                        component: PicwordPetList,
                        meta: { requiresAuth: true }
                    },
                    {
                        path: 'add',
                        name: ROUTE_NAME_PICWORD.PET.ADD,
                        component: PicwordPetAdd,
                        meta: { requiresAuth: true }
                    },
                    {
                        path: ':id/edit',
                        name: ROUTE_NAME_PICWORD.PET.EDIT,
                        component: PicwordPetEdit,
                        meta: { requiresAuth: true }
                    },
                    {
                        path: ':id/detail',
                        name: ROUTE_NAME_PICWORD.PET.DETAIL,
                        component: PicwordPetDetail,
                        meta: { requiresAuth: true }
                    }
                ]
            }
        ]
    }
];
